import React from "react";

const renderRow = (title, value) => (
  <tr key={title}>
    <td className="field-title">{title}</td>
    <td className="field-value">{value || "-"}</td>
  </tr>
);

const renderFeatures = (featuresArray) => {
  if (!featuresArray || featuresArray.length === 0) return null;

  return (
    <>
      <tr>
        <td colSpan="2">
          <strong>Features</strong>
        </td>
      </tr>
      {featuresArray.map((feature, index) =>
        renderRow(feature.name || `Feature ${index + 1}`, feature.value || "-")
      )}
    </>
  );
};

const FamilyCard = ({ family }) => {
  return (
    <div className="data-card">
      <table className="data-table">
        <tbody>
          {renderRow("Name", family.name)}
          {renderRow("Description", family.description)}
          {renderRow("Unique Properties", family.uniqueProperties)}
          {renderRow("Bio", family.bio)}
          {renderRow("Tags", family.tags)}
          {renderRow("Subcategory", family.subcategory)}
          {renderRow("Category", family.category)}
          {renderRow("Factory", family.factory)}
          {renderRow("Factory URL", family.factoryUrl)}
          {renderRow("In Active Sale", family.inActiveSale)}
          {renderRow("In Active Production", family.inActiveProduction)}
          {renderRow("Owner", family.owner?.name)}
          {renderRow("Owner Email", family.owner?.email)}
          {renderRow("Created By", family.createdBy?.name)}
          {renderRow("Created By Email", family.createdBy?.email)}
          {renderRow("Updated By", family.updatedBy?.name)}
          {renderRow("Updated By Email", family.updatedBy?.email)}
          {family.usages && renderRow("Usages", family.usages.join(", "))}
          {renderFeatures(family.featuresArray)}
        </tbody>
      </table>
    </div>
  );
};

export default FamilyCard;
